/**
 *
 * @description 2024黑五赠送care购物主链路全露出，黑五结束再恢复仅结账页露出
 * @date 2024/11/06 15:31:53
 * @author haifn
 * @links https://arashivision.feishu.cn/wiki/ZGbkw09nEihDXqkUjfwcSh8RneF
 * @times 2024.11.13 16:00 - 2025.01.03 16:00
 */
import CampaignBase from '@/components/activity/CampaignBase';
import cloneDeep from 'lodash/cloneDeep';

class BlackFridayCareGiftsForUS extends CampaignBase {
  constructor(props) {
    super(props);
    this.isProd = props.isProd;
    this.LANG = props.LANG;
    this.country = props.country;

    // 活动地区 - 仅US
    this.enabledArea = ['US'];

    // 活动开始结束时间
    this.timeStampConfig = {
      'now': new Date().getTime(),
      '2024-11-13 16:00:00': 1731484800000, // 开始时间
      '2025-01-03 16:00:00': 1735891200000, // 结束时间
    };
  }

  /* 判断活动是否生效 */
  enable = () => {
    // 是否为生效地区
    if (!this.enabledArea.includes(this.country?.code)) return false;

    // 是否为生效时间
    if (this.timeStampConfig.now > this.timeStampConfig['2025-01-03 16:00:00']) return false;

    return true;
  };

  /* 过滤增值服务care，取消care加购 */
  filterCartMatchCare = () => {
    return this.enable();
  };

  /* 产品页关闭care / flexicare加购入口 */
  filterCareFromProductActivityGifts = ({ activityGifts = [] }) => {
    if (!this.enable()) return activityGifts;
    let activityGiftsAfterFilterCare = activityGifts;

    // 弃用该方式，之后判断是否为某个增值服务类型需要接口加上
    // let activityGiftsAfterFilterCare = cloneDeep(activityGifts).filter(
    //   (o) => !ExtraBindServiceConfig.getServiceType(o.commodityId)?.includes('care')
    // );
    return activityGiftsAfterFilterCare;
  };

  /* 产品页隐藏care / flexicare加购入口，从CSS上隐藏，否则无法通过状态管理展示LearnMore弹窗 */
  hideCareFromProductPage = ({ extraBindServiceList = [] }) => {
    if (!this.enable()) return extraBindServiceList;
    extraBindServiceList.forEach((o) => {
      o.hideInProductPage = o.extraType?.includes('care');
    });
    return extraBindServiceList;
  };

  /* 购物车接口过滤增值服务care */
  filterCareFromLoadCartDetail = ({ items = [] }) => {
    if (!this.enable()) return items;
    let itemsAfterFilterCare = cloneDeep(items).map((o) => {
      o.bind_services = o?.bind_services?.filter((o) => !o.type?.includes('care')) ?? [];
      return o;
    });
    return itemsAfterFilterCare;
  };
}

export default BlackFridayCareGiftsForUS;
